import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import DesignTab from "./DesignTab/DesignTab";
import { useEffect } from "react";
import { selectProjectNo, setProjectNoInRedux } from "./DesignTab/designSlice";
import SettingsPage from "./SettingPage/SettingsPage";
import { RoomTab } from "./RoomTab/RoomTab";
import { useHydrateProjectTabFromUrl } from "./hooks/useHydradeProjectTabFromUrl";
import { useGetMultiplacerProjectsSingleProjectQuery } from "../openapi";
import { ProjectMembers } from "./ProjectMembers/ProjectMembers";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { resetReduxForProjectChange } from "./app/store";
import { DrofusForekomsterPage } from "./DrofusForekomster/DrofusForekomsterPage";

export const ProjectPage: React.FC = () => {
  const projectNo = useLocation().pathname.split("/")[1];
  const projectNoNumber = Number(projectNo);

  const projectNoIs8Digits = /^\d{8}$/.test(projectNo);
  useHydrateProjectTabFromUrl();
  const dispatch = useAppDispatch();
  const reduxProjectNo = useAppSelector(selectProjectNo);

  useEffect(() => {
    if (!projectNoIs8Digits) return;

    if (reduxProjectNo > 0 && reduxProjectNo !== projectNoNumber) {
      dispatch(resetReduxForProjectChange(projectNoNumber));
      return;
    }

    if (reduxProjectNo !== projectNoNumber) {
      dispatch(setProjectNoInRedux(projectNoNumber));
    }
  }, [dispatch, projectNoIs8Digits, projectNoNumber, reduxProjectNo]);

  const { data: project } = useGetMultiplacerProjectsSingleProjectQuery(
    {
      projectNo: projectNoNumber,
    },
    {
      skip: !projectNoIs8Digits,
    }
  );

  return (
    <>
      {!projectNoIs8Digits && <div>Ugyldig prosjektnummer i URL</div>}
      <Routes>
        {project != null && (
          <>
            <Route path={"/design"} element={<DesignTab />} />
            <Route path={"/room"} element={<RoomTab />} />
            <Route path={"/forekomster"} element={<DrofusForekomsterPage />} />
            <Route path={"/settings"} element={<SettingsPage />} />
            <Route path={"/members"} element={<ProjectMembers />} />
          </>
        )}
      </Routes>
    </>
  );
};
